<template>
	<section class="Email">
		<Form :form="form" :data="formData" @change="onChange" />
		<Button @click="onSendEmail" :disabled="!(title && body)">送信する</Button>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				title: '',
				body: ''
			};
		},
		methods: {
			onChange(key, value) {
				this[key] = value;
			},
			onSendEmail() {
				this.$emit('send', { title: this.title, body: this.body });
			}
		},
		computed: {
			form() {
				return [
					{
						type: 'text',
						name: 'title',
						label: '名前',
						placeholder: '名前'
					},
					{
						type: 'text',
						name: 'body',
						label: 'ご用件',
						placeholder: 'ご用件',
						multiline: true
					}
				];
			},
			formData() {
				return {
					title: this.title,
					body: this.body
				};
			}
		}
	};
</script>

<style scoped lang="scss">
	.Email {
		padding: 1rem 1.6rem;
		
		/deep/ .Form {
			.input-area {
				input,
				textarea {
					border: solid 1px rgba(0, 0, 0, 0.1);
					background-color: #f9f9f9;
				}
			}
		}

		.Button {
			margin-top: 1rem;
			width: 100%;
		}
	}
</style>
